'use client';
import { useState, useEffect, useCallback } from 'react';
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { SplashScreen } from 'src/components/loading-screen';
import { useAuthContext } from '../hooks';
import { CONFIG } from 'src/config-global';

export function GuestGuard({ children }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { loading, authenticated } = useAuthContext();
  const [isChecking, setIsChecking] = useState(true);
  
  const returnTo = searchParams.get('returnTo') || CONFIG.auth.redirectPath;

  const checkPermissions = useCallback(() => {
    if (loading) {
      return;
    }

    if (authenticated) {
      router.replace(returnTo);
      return;
    }

    setIsChecking(false);
  }, [authenticated, loading, returnTo, router]);

  useEffect(() => {
    checkPermissions();
  }, [checkPermissions]);

  // If authenticated, show splash screen while redirecting
  if (loading || (authenticated && isChecking)) {
    return <SplashScreen />;
  }

  // If authenticated, don't render children (redirect is happening)
  if (authenticated) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
